exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stargate-login[data-v-868ae738] {\n    position: fixed; top: 0; left: 0; z-index: 9999;\n    width: 100%; height: 100%;\n}\n.stargate-login-box[data-v-868ae738] {\n    position: absolute; top: 46%; left: 50%;\n    transform: translate(-50%, -45%);\n    width: 90%;\n    max-width: 280px;\n}\n", ""]);

// exports
